//#region import libraries
import React from 'react';
// sltying
import { Colors } from '_styles';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { selectWaitingTimes, setBeaconAreaFilter, selectBeaconAreaFilter } from '_redux/slices/beacons/beacons';
//#endregion

const ListSelector = (props) => {
    //#region redux
    const dispatch = useDispatch();
    const waitingAreas = useSelector(selectWaitingTimes)
    const beaconAreaFilter = useSelector(selectBeaconAreaFilter)
    //#endregion

    const handleSelectChange = (val) => {
        dispatch(setBeaconAreaFilter(val.target.value))
    }

    return (
        <select
            onChange={handleSelectChange}
            value={beaconAreaFilter}
            style={{
                width: 300, borderStyle: 'solid', borderWidth: 0.2, borderColor: Colors.GRAY_LIGHT, borderRadius: 5, padding: 5,
                fontSize: 16, color: Colors.GRAY_DARK
            }}>
            <option value="all-beacons">All Beacons</option>
            {waitingAreas.map((waitingArea => {
                return (
                    <option value={waitingArea.details.beaconId}>{waitingArea.details.name}</option>
                )
            }))}
        </select>
    );
};

export default ListSelector;
